import UserList from "../components/UserList";


const ManageUser = () => {
  return (
    <div className="min:h-screen h-full bg-white text-gray-800 dark:bg-gray-900">
      <div className="h-full pt-4">
        <UserList />
      </div>
    </div>
  );
};

export default ManageUser;
